class InvoiceListItem {
    constructor() {
        this.id = null;
        this.date = null;
        this.amount = null;
        this.status = null;
    }
}
const keysOfInvoiceListItem = ["id", "date", "amount", "status"];

export { InvoiceListItem, keysOfInvoiceListItem };
